import React from 'react';
import StepActions from '../shared/StepActions';
import StepShell from '../shared/StepShell';
import { DEPOSITION_OPTIONS } from '../shared/options';

// Deposition type of every skeleton figure belonging to the grave.
export default function SkeletonStep({ skeletons = [], onNext, onCancel }) {
  const [depositions, setDepositions] = React.useState(() =>
    skeletons.reduce(
      (acc, skeleton) => ({ ...acc, [skeleton.id]: String(skeleton.depositionType ?? '') }),
      {}
    )
  );

  const update = (id, value) => setDepositions((prev) => ({ ...prev, [id]: value }));

  return (
    <StepShell>
      <h3>Skeleton Data</h3>
      {skeletons.length === 0 ? (
        <p>No skeleton figures found for this grave.</p>
      ) : (
        <div className="skeleton-list">
          {skeletons.map((skeleton) => (
            <div key={skeleton.id} className="card mb-3">
              <div className="card-body">
                <h5>Skeleton {skeleton.id}</h5>
                <select
                  className="form-select"
                  value={depositions[skeleton.id] || ''}
                  onChange={(e) => update(skeleton.id, e.target.value)}
                >
                  {DEPOSITION_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ))}
        </div>
      )}
      <StepActions
        onNext={() => onNext({ skeletonDepositions: depositions })}
        onCancel={onCancel}
      />
    </StepShell>
  );
}
